/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostNameAndTldAndApiCurrencyCodeCredentialData
 */
export interface HostNameAndTldAndApiCurrencyCodeCredentialData {
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeCredentialData
     */
    hostName?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeCredentialData
     */
    tld?: string;
    /**
     * 
     * @type {string}
     * @memberof HostNameAndTldAndApiCurrencyCodeCredentialData
     */
    currencyCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof HostNameAndTldAndApiCurrencyCodeCredentialData
     */
    apiKeyConfigured?: boolean;
}

/**
 * Check if a given object implements the HostNameAndTldAndApiCurrencyCodeCredentialData interface.
 */
export function instanceOfHostNameAndTldAndApiCurrencyCodeCredentialData(value: object): value is HostNameAndTldAndApiCurrencyCodeCredentialData {
    return true;
}

export function HostNameAndTldAndApiCurrencyCodeCredentialDataFromJSON(json: any): HostNameAndTldAndApiCurrencyCodeCredentialData {
    return HostNameAndTldAndApiCurrencyCodeCredentialDataFromJSONTyped(json, false);
}

export function HostNameAndTldAndApiCurrencyCodeCredentialDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostNameAndTldAndApiCurrencyCodeCredentialData {
    if (json == null) {
        return json;
    }
    return {
        
        'hostName': json['hostName'] == null ? undefined : json['hostName'],
        'tld': json['tld'] == null ? undefined : json['tld'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'apiKeyConfigured': json['apiKeyConfigured'] == null ? undefined : json['apiKeyConfigured'],
    };
}

export function HostNameAndTldAndApiCurrencyCodeCredentialDataToJSON(json: any): HostNameAndTldAndApiCurrencyCodeCredentialData {
    return HostNameAndTldAndApiCurrencyCodeCredentialDataToJSONTyped(json, false);
}

export function HostNameAndTldAndApiCurrencyCodeCredentialDataToJSONTyped(value?: HostNameAndTldAndApiCurrencyCodeCredentialData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostName': value['hostName'],
        'tld': value['tld'],
        'currencyCode': value['currencyCode'],
        'apiKeyConfigured': value['apiKeyConfigured'],
    };
}

